import { jsx as e } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { BaseList as C } from "../../../../internal/BaseList/BaseList.js";
import { GrantItem as _ } from "../GrantItem/GrantItem.js";
import { getGrantConfig as b } from "../GrantItem/utils.js";
import { GRANT_ADJUSTMENT_DETAILS as R } from "../GrantAdjustmentDetails/constants.js";
import { GrantRepaymentDetails as T } from "../GrantRepaymentDetails/GrantRepaymentDetails.js";
import A from "../../../../internal/SegmentedControl/SegmentedControl.js";
import B from "../../../../../core/Context/useCoreContext.js";
import { useState as G, useMemo as l, useCallback as D } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import E from "../../../../internal/Button/Button.js";
import { ButtonVariant as U } from "../../../../internal/Button/types.js";
import { CapitalHeader as k } from "../../../../internal/CapitalHeader/CapitalHeader.js";
const u = ({ grants: t, showDetails: c }) => /* @__PURE__ */ e(C, { classNames: "adyen-pe-grant-list__items", children: t.map((n) => /* @__PURE__ */ e("li", { children: /* @__PURE__ */ e(_, { grant: n, showDetails: c.bind(null, n) }) }, n.id)) }), Y = ({ grantList: t, hideTitle: c, newOfferAvailable: n, onNewOfferRequest: g }) => {
  const [v, h] = G(), [a, y] = G(), { i18n: N } = B(), [i, m] = l(() => {
    const s = [], r = [];
    return t == null || t.forEach((o) => {
      o.status === "Active" || o.status === "Pending" ? s.push(o) : r.push(o);
    }), [s, r];
  }, [t]), f = l(() => t.length > 1 && i.length && m.length ? "SegmentedGrants" : "UnifiedGrants", [i.length, t.length, m.length]), S = l(() => n && !i.some((s) => s.status === "Pending"), [i, n]), d = l(() => a && b(a), [a]), w = D(() => h(void 0), []), p = D((s, r) => {
    h(r), y(s);
  }, []);
  if (a)
    switch (v) {
      case R.unscheduledRepayment: {
        if (d != null && d.hasUnscheduledRepaymentDetails)
          return /* @__PURE__ */ e(T, { grant: a, onDetailsClose: w });
        break;
      }
    }
  return /* @__PURE__ */ e("div", { className: "adyen-pe-grant-list", children: [
    /* @__PURE__ */ e("div", { className: "adyen-pe-grant-list__header-container", children: [
      /* @__PURE__ */ e(k, { hideTitle: c, titleKey: "capital.businessFinancing" }),
      S ? /* @__PURE__ */ e(E, { onClick: g, className: "adyen-pe-grant-list__offer-button", variant: U.SECONDARY, children: N.get("capital.seeNewOffer") }) : null
    ] }),
    f === "UnifiedGrants" && /* @__PURE__ */ e(u, { grants: t, showDetails: p }),
    f === "SegmentedGrants" && /* @__PURE__ */ e(
      A,
      {
        items: [
          {
            label: "capital.inProgress",
            content: /* @__PURE__ */ e(u, { grants: i, showDetails: p }),
            id: "active"
          },
          {
            label: "capital.closed",
            content: /* @__PURE__ */ e(u, { grants: m, showDetails: p }),
            id: "inactive"
          }
        ],
        defaultItem: "active"
      }
    )
  ] });
};
export {
  Y as GrantsDisplay
};
